import { Block } from 'framework7-react';
import React, { FC, useState } from 'react';
import styles from './DangerDetailsStyle.module.css';
import { PopupPageTemplate } from '@/components/uiParts/Template/PopupPageTemplate/PopupPageTemplate';
// 追加: 共通の動画埋め込み（サムネイル→クリックで再生）コンポーネント
const YoutubeEmbed: React.FC<{ videoId: string; title: string }> = ({
  videoId,
  title,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const thumbnail = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
  return (
    <div className={styles.videoWrapper}>
      {!isPlaying && (
        <>
          <img
            src={thumbnail}
            alt={`${title} サムネイル`}
            className={styles.videoThumbnail}
            onClick={() => setIsPlaying(true)}
          />
          <span
            className={styles.playButton}
            onClick={() => setIsPlaying(true)}
            aria-label="再生"
            role="button"
          />
        </>
      )}
      {isPlaying && (
        <iframe
          className={styles.videoIframe}
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1`}
          title={title}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      )}
    </div>
  );
};
export const DangerDetails: FC = () => {
  return (
    <PopupPageTemplate pageName="evaluation" title="危険な運転ってどんな運転？">
      <Block className={styles.container}>
        {/* Q/A intro */}
        <div className={styles.intro}>
          <p className={styles.q}>
            <span className={styles.label}>Q.</span>
            危険な運転って、具体的にどのようなものですか？
          </p>
          <p className={styles.a}>
            <span className={styles.label}>A.</span>
            当社では、このような運転を危険な運転と定めています
          </p>
        </div>

        {/* 1. 速度超過 */}
        <section className={styles.block} aria-labelledby="sp1">
          <div className={styles.head}>
            <span className={styles.num}>1</span>
            <h3 id="sp1" className={styles.title}>
              速度超過
            </h3>
          </div>
          <div className={styles.body}>
            <span className={styles.badge}>判定の基準</span>
            <p>
              一定区間（<span className={styles.noteMark}>注1</span>
              ）の平均速度が
              道路種別ごとに設定された速度基準を超えた場合に「速度超過」と判定します。
            </p>
            <p className={styles.note}>
              （注1）「一定区間」のイメージは、一般道路では「信号～信号」まで、高速道路では「約600～700メートル」が目安となります。
            </p>
          </div>
        </section>

        {/* 2. 急アクセル・急ブレーキ */}
        <section className={styles.block} aria-labelledby="sp2">
          <div className={styles.head}>
            <span className={styles.num}>2</span>
            <h3 id="sp2" className={styles.title}>
              急アクセル・急ブレーキ
            </h3>
          </div>
          <div className={styles.body}>
            <span className={styles.badge}>判定の基準</span>
            <p>
              一定以上の加減速度（<span className={styles.noteMark}>注2</span>
              ）を検知した場合に 「急アクセル・急ブレーキ」と判定します。
            </p>
            <p className={styles.note}>
              （注2）1秒間に時速10km程度の加減速がある場合が目安となります。
            </p>
          </div>
        </section>

        {/* 下部の2つの囲み：動画埋め込み（置き換え） */}
        <section className={styles.media}>
          <h4 className={styles.mediaTitle}>急アクセルの画像または動画</h4>
          <YoutubeEmbed videoId="BOCzIrWkITQ" title="急アクセルの動画" />
        </section>

        <section className={styles.media}>
          <h4 className={styles.mediaTitle}>急ブレーキの画像または動画</h4>
          <YoutubeEmbed videoId="dg98AtY5hZg" title="急ブレーキの動画" />
        </section>
      </Block>
    </PopupPageTemplate>
  );
};

export default DangerDetails;
